import ApiBase from '../ApiBase';

class Users extends ApiBase {
    route = '/networking/users';

    enabled(params) {
        return this.get(this.route, params);
    }

    saveProfile(data) {
        return this.post(`${this.route}/profile`, data);
    }
}

export default new Users;
